import { render, staticRenderFns } from "./order-view-delivery.vue?vue&type=template&id=630f3c2a&"
import script from "./order-view-delivery.vue?vue&type=script&lang=js&"
export * from "./order-view-delivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports